import React, { FC, useEffect, useMemo, useState } from 'react';
import { Button, Divider, Drawer, Tree } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import s from '././XPathStructureTarget.scss';
import {
  getDrawerData,
  getIndexSearchText,
  loopSearchLabelDrawer,
} from '../../../../helpers/helpers';
import { IShowcase } from '../../../../interfaces/interfaces';
import Search from 'antd/es/input/Search';
import { DataNode } from 'antd/es/tree';

interface IXPathStructureTarget {
  structureData: Array<unknown>;
  targetData: Array<IShowcase>;
  handleSave: (row: Array<unknown>) => void;
  setDrawerKey: (key: string) => void;
  drawerKey: string;
}
export const XPathStructureTarget: FC<IXPathStructureTarget> = ({
  structureData,
  targetData,
  setDrawerKey,
  handleSave,
  drawerKey,
}) => {
  const [desc, setDesc] = useState('');
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [autoExpandParent, setAutoExpandParent] = useState(true);

  const onExpand = (newExpandedKeys: React.Key[]) => {
    setExpandedKeys(newExpandedKeys);
    setAutoExpandParent(false);
  };
  const onCheck = (keys) => {
    setCheckedKeys(keys);
  };
  const handleChangeDesc = (e) => {
    const value = e.target.value;
    setDesc(value);
  };
  const handleSaveXPathes = () => {
    //TODO Добавить описание при выборе кастома в строку
    const row = targetData.find((r) => r.key === drawerKey);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    handleSave({ ...row, args: [...checkedKeys], customComment: desc });
    setDrawerKey('');
    setCheckedKeys([]);
  };
  const treeDrawerData = getDrawerData(structureData);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const data = [...treeDrawerData];
    const exp: string[] = value ? loopSearchLabelDrawer(data, value) : [];
    setExpandedKeys(exp as string[]);
    setSearchValue(value);
    setAutoExpandParent(true);
  };

  useEffect(() => {
    const row = targetData.find((r) => r.key === drawerKey);
    if (row) {
      setCheckedKeys(row?.args);
      setDesc(row.customComment || '');
    }
  }, [targetData, drawerKey]);

  const treeData = useMemo(() => {
    const loop = (data: DataNode[]): DataNode[] =>
      data.map((item) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const strTitle = item.title?.props?.children as string;
        const index = getIndexSearchText(strTitle, searchValue) || 0;
        const beforeStr = strTitle.substring(0, index);
        const afterStr = strTitle.slice(index + searchValue.length);
        const title =
          index > -1 ? (
            <span>
              {beforeStr}
              <span className='site-tree-search-value'>{searchValue}</span>
              {afterStr}
            </span>
          ) : (
            <span>{strTitle}</span>
          );
        if (item.children) {
          return { title, key: item.key, children: loop(item.children) };
        }

        return {
          title,
          key: item.key,
        };
      });

    return loop(treeDrawerData);
  }, [treeDrawerData, searchValue]);
  return (
    <Drawer
      bodyStyle={{ padding: '24px 24px 0 24px' }}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>xpath</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
            <Button>Отменить</Button>
            <Button onClick={handleSaveXPathes} type={'primary'}>
              Выбрать
            </Button>
          </div>
        </div>
      }
      placement='right'
      onClose={() => setDrawerKey('')}
      open={!!drawerKey}
    >
      <TextArea onChange={handleChangeDesc} value={desc} />
      <Divider />
      <div className={s.VizualuzationXPathes}>
        <Search style={{ marginBottom: 8 }} placeholder='Search' onChange={onChange} />

        <Tree
          className='draggable-tree'
          checkable
          checkedKeys={treeData.length ? checkedKeys : [] || []}
          selectable={false}
          onCheck={onCheck}
          treeData={treeData}
          onExpand={onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
        />
      </div>
    </Drawer>
  );
};
